import { Button, message } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import SearchInput from './SearchInput';
import Item from '../../Tab/Item';
import PermissionSelect from '../../PermissionSelect';
import {
  FileType,
  joyspacePermissionType,
  PermissionEnum,
  SharesMembersType,
  ShareType,
  TabKeyType,
} from '../../types';
import Tabs from '../../Tab';
import ShareSearchModal from '../../Share';
import {
  getAllSharesMembers,
  getSharesPermissionType,
  getUser,
} from '../../api/user';
import noSearchIcon from '../../assets/images/noData.png';
import noDataIcon from '../../assets/images/notfind-delete.png';
import {
  getJoySpaceDelPermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadOnlyPermission,
  JoyspacePermissionType,
} from '../../config/permissions.config';
import { getPermissionText } from '../../MemberSelect/config';
import PermissionModal from '../../PermissionModal';
import {
  batchPermission,
  batchRemove,
  removePermission,
  setPermission,
} from '../../api/permission';
import CardItem from '../CardItem';

const parames = {
  page_id: '',
  type: FileType.Folder,
  start: 1,
  length: 30,
  memberType: SharesMembersType.ALL,
  keyName: '',
};

const MembersSetting = (props: any) => {
  const { folderId, permissions } = props;
  const [membersList, setMembersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadMore, setLoadMore] = useState(false);
  // const [permissionCanSelect, setPermissionCanSelect] = useState(false);
  const [isOnBottomLoading, setOnBottomLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [myPermissionType, setMyPermissionType] = useState(
    getJoySpaceReadOnlyPermission()
  );
  const [currentUserInfo, setCurrentUserInfo] = useState<any>();

  const getUserPermissionList = async (_parames: any, userInfo: any = {}) => {
    getAllSharesMembers(parames)
      .then((res: any) => {
        const [data, err] = res;
        if (err) {
          if (!err['errResolved']) {
            message.error(err.msg);
          }
          return;
        }
        if (data) {
          const { members, hasMore } = data;
          let result = members.map((item: any) => {
            item.isLoginUser =
              item.memberType === SharesMembersType.CONTACT &&
              item.memberId === userInfo.id;
            let desc = '';
            if (item.memberType === SharesMembersType.CONTACT) {
              const positionName = item.user.position_name
                ? item.user.position_name
                : '暂无填写';
              desc = `${item.user.org_name}-${positionName}`;
            } else if (item.memberType === SharesMembersType.DEPARTMENT) {
              desc = item.fullName;
              if (item.nodeType) {
                item.type = TabKeyType.WorkLine;
              } else {
                item.type = TabKeyType.Department;
              }
            } else {
              desc = `${item.memberCount}人`;
            }
            //   console.log(desc, 'descdescdescdescdescdesc');
            item.desc = desc;
            item.isChecked = false;
            return item;
          });
          if (_parames.start !== 1) {
            result = [].concat([...membersList], result || []);
          }
          setLoadMore(hasMore);
          setMembersList(result);
        }
      })
      .finally(() => {
        setLoading(false);
        setOnBottomLoading(false);
      })
      .catch(err => {
        message.error(err);
      });
  };

  const getMyPermissionType = async () => {
    const res: any = await getSharesPermissionType(folderId);

    const [data, err] = res;
    if (err) {
      if (!err['errResolved']) {
        message.error(err.msg);
      }
      return;
    }
    setMyPermissionType(data);
  };

  const getCurrentUserInfo = () => {
    getUser().then(data => {
      setCurrentUserInfo(data);
      getMyPermissionType();
      getUserPermissionList(parames, data);
    });
  };

  useEffect(() => {
    parames.start = 1;
    parames.keyName = '';
    parames.page_id = folderId;
    setLoading(true);
    getCurrentUserInfo();
    return () => {
      parames.start = 1;
      parames.keyName = '';
    };
  }, []);

  const refreshUserList = useCallback(() => {
    getMyPermissionType();
    getUserPermissionList(parames, currentUserInfo);
  }, [getMyPermissionType, getUserPermissionList, currentUserInfo]);

  // 修改权限上报
  // const handlePermissionClick = (item: any, permissionType: any) => {
  //   const pageId = parames.page_id;
  //   const { memberId, user, isLoginUser } = item;
  //   let tenant_id = '';
  //   if (user) {
  //     tenant_id = user.tenant_id;
  //   }

  //   analysisLog(
  //     "xtbg_jzb_joyspace_home_1676548210761",
  //     "43",
  //     pageId,
  //     memberId,
  //     tenant_id,
  //     permissionType.toString(),
  //     isLoginUser
  //   );
  // };

  const setCurrentPermissionType = useCallback(
    // eslint-disable-next-line max-params
    async (sharesId = '', item: any, idx = -1, val: any) => {
      const res: any = await getSharesPermissionType(folderId);
      const [currentPermissionType, err] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return;
      }
      if ((currentPermissionType as any) === joyspacePermissionType.ReadDel) {
        message.error('您不是协作者，无法完成操作');
        setMyPermissionType(currentPermissionType);
        return false;
      }
      // 权限不够
      if (
        currentPermissionType > item.permissionType ||
        currentPermissionType > Math.abs(val) ||
        (!item.isLoginUser &&
          (currentPermissionType as any) === getJoySpaceReadOnlyPermission() &&
          val === joyspacePermissionType.ReadDel)
      ) {
        // eslint-disable-next-line no-debugger
        // debugger;
        setMyPermissionType(currentPermissionType as any);
        message.error('暂无权限操作');
        return false;
      }
      return true;
    },
    [membersList, folderId]
  );

  const handleMenuClick = useCallback(
    async (val: any, id) => {
      let list: any = JSON.parse(JSON.stringify(membersList));
      const idx = list.findIndex((item: any) => item.id === id);
      // 移除
      if (idx === -1) {
        return;
      }
      const item: any = list[idx];
      const hasPermission = await setCurrentPermissionType(
        item.id,
        item,
        idx,
        val
      );
      if (!hasPermission) {
        return;
      }
      if (val === getJoySpaceDelPermission()) {
        let text = item.isLoginUser
          ? `确定删除自己的个人权限吗？`
          : '确定删除该成员吗？';
        // let text = item.isLoginUser
        //     ? `删除后，您将失去对${
        //           type === FileType.Folder ? '文件夹' : '文件'
        //       }的【全部】权限。是否确认此操作？`
        //     : '确定删除该协作者吗？';
        PermissionModal({
          text,
          visibleModal: true,
          onOk: () => {
            batchRemove([id], props.folderId).then(res => {
              const [data, error] = res;
              if (error) {
                message.error('暂无权限操作');
                return;
              }
              list.splice(idx, 1);
              setMembersList(list);
              if (!item.isLoginUser) {
                parames.start = 1;
                setMembersList([]);
                setLoading(true);
                refreshUserList();
              }
              // handlePermissionClick(item, val);
              message.success(`已删除 ${item.name} 成员`);
              if (item.isLoginUser) {
                setMyPermissionType(joyspacePermissionType.ReadNothing as any);
                // setVisibleModal(false);
                window.location.reload();
              }
              // setCurrentPermissionType(item.id, item, idx, val);
            });
          },
        });
      } else if (item.isLoginUser && val > myPermissionType) {
        const text = `变更后，您将失去知识库的【${getPermissionText(
          myPermissionType
        )}】权限。是否确认此操作？`;
        PermissionModal({
          text,
          visibleModal: true,
          onOk: async () => {
            batchPermission([
              {
                permission: val,
                sendMessage: true,
                shareId: item.id,
                resourceId: props.folderId,
              },
            ]).then((res: any) => {
              if (!res) {
                return;
              }
              setMembersList([]);
              setLoading(true);
              parames.start = 1;
              message.success(
                `已将 ${item.name} 的权限改为${getPermissionText(val, true)}`
              );
              // handlePermissionClick(item, val);
              refreshUserList();
              // setCurrentPermissionType(item.id, item, idx, val);
            });
          },
        });
      } else {
        batchPermission([
          {
            permission: val,
            sendMessage: true,
            shareId: item.id,
            resourceId: props.folderId,
          },
        ]).then(res => {
          if (!res) {
            return;
          }
          setMembersList([]);
          setLoading(true);
          parames.start = 1;
          message.success(
            `已将 ${item.name} 的权限改为${getPermissionText(val, true)}`
          );
          // handlePermissionClick(item, val);
          refreshUserList();
          // console.log(res, "resresresresres==>");
          // setCurrentPermissionType(item.id, item, idx, val);
        });
      }
    },
    [membersList, myPermissionType, setCurrentPermissionType, refreshUserList]
  );

  const handleRightNode = useCallback(
    (item: any) => {
      const ownerArr = membersList.filter(
        (item: any) =>
          item.memberType === SharesMembersType.CONTACT &&
          item.permissionType === getJoySpaceReadAllPermission()
      );
      // console.log(ownerArr, 'ownerArrownerArrownerArrownerArr')
      return (
        <PermissionSelect
          onChange={(values: any) => {
            handleMenuClick?.(values, item.id);
          }}
          isOnlyText={
            (!item.isLoginUser &&
              (myPermissionType as any) === joyspacePermissionType.ReadOnly) ||
            myPermissionType > item.permissionType ||
            item.owner || // 知识库所有者不支持变更
            (parames.keyName === '' && // 知识库，没有搜索关键字且只有一个可管理时，可以修改权限
              ownerArr.length === 1 &&
              item.permissionType === getJoySpaceReadAllPermission())
            // !permissionCanSelect // 多选框有选中时，禁止改变
          }
          type={FileType.Folder}
          permissionType={myPermissionType}
          propsValue={item.permissionType}
          isDisableAll={
            item.memberType === SharesMembersType.DEPARTMENT ||
            item.memberType === SharesMembersType.GROUP
          }
          isShowDelMenu={true}
          ownerNum={ownerArr.length}
          isLoginUser={item.isLoginUser}
          hasTip={false}
          isKnowledge={true}
        />
      );
    },
    [
      handleMenuClick,
      myPermissionType,
      // type,
      membersList,
      // permissionCanSelect,
    ]
  );

  const onButtom = useCallback(() => {
    if (!isLoadMore || isOnBottomLoading) {
      return;
    }
    setOnBottomLoading(true);
    parames.start++;
    getUserPermissionList(parames, currentUserInfo);
  }, [isLoadMore, getUserPermissionList, currentUserInfo, isOnBottomLoading]);

  const onSearch = (value: any) => {
    setLoading(true);
    const trimValue = value.trim();
    parames.keyName = trimValue;
    parames.start = 1;
    getUserPermissionList(parames, currentUserInfo);
  };

  const init = () => {
    parames.start = 1;
    // setTotal(0);
  };

  return (
    <div className={styles['setting-members']}>
      <CardItem title="可见范围">
        <div className={styles['setting-visible-container']}>
          <span style={{ color: '#303D4B' }}>仅知识库成员可见</span>
          <span
            style={{ color: '#8F959E', fontSize: '12px', marginLeft: '9px' }}
          >
            创建成功后可添加成员
          </span>
        </div>
      </CardItem>
      <CardItem title="成员管理">
        <div className={styles['setting-members-container']}>
          <div className={styles['members-setting-head']}>
            <div>
              <SearchInput onSearch={onSearch} init={init} />
            </div>
            <div>
              <Button
                type="primary"
                onClick={() => {
                  setIsModalVisible(true);
                }}
                className={styles['add-members-btn']}
              >
                + 添加成员
              </Button>
            </div>
          </div>
          <div className={styles['members-setting-body']}>
            <div className={styles['tabs-header']}>
              <span>成员</span>
              <span style={{ paddingLeft: '7px' }}>权限</span>
            </div>
            <div>
              <Tabs
                list={membersList}
                handleMenuClick={handleMenuClick}
                loading={loading}
                isLoadMore={isLoadMore}
                onButtom={onButtom}
                noDataUrl={parames.keyName ? noSearchIcon : noDataIcon}
                noDataText={parames.keyName ? '搜索无结果' : '暂无数据'}
                rightRenderDOM={handleRightNode}
                myPermissionType={myPermissionType}
                type={FileType.Folder}
                hasTabs={false}
                hasListHeader={false}
                customItemStyle={{
                  'custom-tab-item': styles['custom-tab-item'],
                }}
                customListStyle={{
                  'custom-list-box': styles['custom-list-box'],
                }}
                id={folderId}
                hasCheckbox={false}
                isKnowledge={true}
              />
            </div>
          </div>
        </div>
      </CardItem>
      <ShareSearchModal
        title="添加成员"
        id={folderId}
        isModalVisible={isModalVisible}
        permissions={permissions}
        permissionType={myPermissionType}
        type={parames.type}
        onCancel={() => setIsModalVisible(false)}
        onOK={(parames: any) => {
          // const { data, shareType } = parames;
          refreshUserList();
        }}
        isShowManageBtn={false}
        isExternalContacts={currentUserInfo?.user_type === 3}
        isShowShareType={false}
        defaultShareType={ShareType.ShareAI}
        isShowHeaderTip={false}
        isKnowledge={true}
      />
    </div>
  );
};

export default MembersSetting;
